/* eslint-disable class-methods-use-this */
import Phase from '../phase-core/Phase';

export default class FrameInit extends Phase.Config {
	run({ scale, frame_opts }) {
		frame_opts.aspect_correction = scale;
		frame_opts.base_color = [0, 1, 0, 1];
	}
}
